import React, { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Form, Select } from 'antd'
import { map } from 'lodash-es'

import {
  createUrl,
  getQueryParams,
} from '../../core/utils/services/queryParams'

import { TASK_VIEW_TYPES } from '../../tasks/constants'
import { DEFAULT_PAGE } from '../constants'

const TaskViewTypeFilter = () => {
  const history = useHistory()
  const { pathname, search } = useLocation()

  const { viewType, viewStatus } = getQueryParams(search)

  const handleChange = useCallback(
    viewType =>
      history.push(
        createUrl(pathname, search, {
          viewType,
          viewStatus: viewType ? viewStatus : '',
          page: DEFAULT_PAGE,
        }),
      ),
    [history, pathname, search, viewStatus],
  )

  return (
    <Form.Item label="Current task view">
      <Select
        style={{ width: '100%' }}
        value={viewType}
        onChange={handleChange}
        allowClear
      >
        {map(TASK_VIEW_TYPES, ({ name, value }) => (
          <Select.Option key={value} value={value}>
            {name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

export default TaskViewTypeFilter
